import Vue from "vue";
import * as VueGoogleMaps from "gmap-vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GMAPS,
    libraries: "places, geometry"
  }
});

new Vue({
  router,
  vuetify,
  render: h => h(App),
  beforeCreate() {
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", function() {
        navigator.serviceWorker
          .register("/sw.js", { scope: "/" })
          .then(function(registration) {
            // eslint-disable-next-line
            console.log("ServiceWorker registration successful! on Scope: " + registration.scope)
          })
          .catch(function(err) {
            // eslint-disable-next-line
            console.log("ServiceWorker registration failed: ", err)
          });
      });
    }
  }
}).$mount("#app");
